module.exports = __webpack_public_path__ + "img/pet4.ee8c8af5.png";